export const blockIconsDeviceAccessTime = (
	<span className='material-symbols-outlined'>access_time</span>
);
